/**
 * Attribute Assignment
 *
 * This JavaScript file handles the detection of mobile devices and preferences for reduced motion.
 * It assigns corresponding data attributes to the body element based on these settings.
 *
 * Dependencies:
 * - isMobile: This function is imported from 'environment/mobile-device-check.js' and is used to detect mobile browsers.
 * - prefersReducedMotion: This function is imported from 'accessibility/reduced-motion-check.js' and is used to check if
 *   the user prefers reduced motion.
 *
 * When the document is ready, this script performs the following tasks:
 * 1. Detects mobile browsers and adds a 'data-mobile-device' attribute to the body if the user is on a mobile device.
 * 2. Sets up a function to toggle the 'data-reduced-motion' attribute on the body based on the user's preference for reduced motion.
 * 3. Triggers the initial check for the user's preference for reduced motion and applies the corresponding attribute to the body.
 * 4. Listens for changes in the user's preference for reduced motion and updates the attribute on the body accordingly.
 */

// Import custom utilities
import isMobile from '../environment/mobile-device-check';
import prefersReducedMotion from '../accessibility/reduced-motion-check';

document.addEventListener('DOMContentLoaded', () => {
  
  const body = document.body;
  
  // Detect mobile browsers
  if (isMobile()) {
	body.setAttribute('data-mobile-device', 'true');
  }
  
  // Function to toggle the reduced motion attribute
  const toggleReducedMotionAttribute = (prefersReducedMotion) => {
	if (prefersReducedMotion) {
	  body.setAttribute('data-reduced-motion', 'true');
	} else {
	  body.removeAttribute('data-reduced-motion');
	}
  };
  
  // Trigger the initial check for reduced motion preference and handle it
  const initialReducedMotionPreference = prefersReducedMotion();
  toggleReducedMotionAttribute(initialReducedMotionPreference);
  
  // Listen for changes in reduced motion preference and handle them
  document.addEventListener('reducedMotionChange', (event) => {
	toggleReducedMotionAttribute(event.detail);
  });
  
});